import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';

// import { useLocation } from "react-router-dom";
import {  getDat2, getDataWithToken, getDataWithTokenDemo, getMasterDataToken, postDat2 } from "../../../Utils/restUtils";
import { getCompanyDetails, getCompanyProfile, getCompanySubscription, getUserData, showUserSubscription } from "../../../CommonURL";

// import InvoicePayment from './InvoicePayment';
// import SubTabs from './Subscription';
// import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import CompanyProfile from './CompanyProfile';
import AboutCompany from './AboutCompany ';
import SubTabs from './Subscription';
import InvoicePayment from './InvoicePayment';
import { useLocation, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import Transparentspinner from '../../Common/loader/Transparentspinner';

const CompanyProfileContain = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const param1 = params.get("id");
    const param2=params.get("user_id")
    const param3=params.get("industryId")
    const authState = useSelector((state) => state.auth);
    const [widgetDetails, setWidgetDetails] = useState({});
    const [personalDetails, setPersonalDetails] = useState({});
    const [userDetails,setUserDetails] =useState({})
    const [subscriptionList, setSubscriptionList] = useState([]);
    const { clientUrl, industryName } = location.state || {};
    
    useEffect(() => {
        masterWidgetData();
        masterUserData();
        getUserDatas()
        getCompanySubscriptionData();
    }, [])


    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
      };

    const getCompanySubscriptionData = async () => {
    setLoading(true);

    const response = await getMasterDataToken(
        getCompanySubscription + `?company_id=${param1}&user_id=${param2}`
    );
    
    if (response?.data?.status === true) {
        const list = response?.data?.data || [];
        

        const formatted = list.map((e, index) => ({
            Si: index + 1,
            PackName: <span>{e.package_name}</span>,
            // InvoiceNo: e.invoice_no,
            StartDate: e.start_date,
            EndDate: e.end_date,
            PayStatus: e.payment_status,
            // CreateBy: e.created_by_name,
            // order_id: e.order_id,
            // id: e.id,
            // customerid: e.customer_id,
            subscriptionStatus: e.subscription_status,
            Status: e.status,
            // Stb_no: e.stb_no
        }));

        setSubscriptionList(formatted);
                

    } else {
        handleApiError(response?.status);
    }

    setLoading(false);
};
    const masterWidgetData = async () => {
        setLoading(true);
        const response = await getDat2(clientUrl,`${getCompanyDetails}?company_id=${param1}`);
        if (response?.status === true) {
            setWidgetDetails(response.data);
        } else {
            handleApiError(response?.status);
        }
        setLoading(false);
    }

    const getUserDatas = async () => {
    setLoading(true);

    const response = await getDataWithToken(
        `${getUserData}?user_id=${param2}`
    );

    if (response?.status === true) {
        setUserDetails(response.data);
    } else {
        handleApiError(response?.status);
    }

    setLoading(false);
};

    const masterUserData = async () => {
        setLoading(true);
        const response = await postDat2(clientUrl,`${getCompanyProfile}?company_id=${param1}`);
        if (response?.status === true) {
            setPersonalDetails(response.data);
        } else {
            handleApiError(response?.status);
        }
        setLoading(false);
    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle="Company Profile" parent="Users" title="Company Profile" />
            <Container fluid={true}>
                <div className="user-profile">
                    <Row>
                        {Object.keys(widgetDetails).length > 0 && (
                            <CompanyProfile details={widgetDetails} refreshSubscription={getCompanySubscriptionData}   refreshData={masterWidgetData} subscription={subscriptionList} personalData={personalDetails}/>
                         )} 
                        <Col xl="3" md="5" className="xl-35 box-col-30">
                            <div className="default-according style-1 faq-accordion job-accordion">
                                <Row>
                                    <Col xl='12'>
                                        {Object?.keys(personalDetails || {})?.length > 0 && (
                                        <AboutCompany personalData={personalDetails} refreshData={masterWidgetData}  subscription={subscriptionList} details={userDetails} />
                                       )}

                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xl="9" md="7" className="xl-65 box-col-70">
                            <Row>
                                <SubTabs param={param1} params={param2} subscription={subscriptionList}  />
                            </Row>
                        </Col>
                        <InvoicePayment param={param1} params={param2} />
                    </Row>
                </div>
            </Container>
        </Fragment>
    );
};
export default CompanyProfileContain;
